import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import Presentation from "./Presentation"
import make_API_call from "../../../../../providers/REST_API"
import { loadInvitationEmail } from "../../../middleware/employeeInvitationToken"

function Container(props) {
	const [registerEmail, setEmail] = useState("")
  const { loadInvitaionTokenEmail, state ,isLoaded} = props
  let obj = {
    token: props.token,
  }
  useEffect(() => {
    loadInvitaionTokenEmail(obj)
  }, [])
  console.log(state)
  if(!isLoaded)
	return (
	
    <div>
      <Presentation {...props} state={state} />
    </div>
		)
	return <p>Loading...</p>
}

const mapStateToProps = (state, ownProps) => {
  return {
    prop: state.prop,
    state: state.employee.invitationToken,
    isLoaded: state.employee.invitationToken["invitationTokenEmail"].isLoading,
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    loadInvitaionTokenEmail: (payload) => {
      dispatch(loadInvitationEmail(payload))
    },
  }
}

// const mapDispatchToProps = (dispatch, ownProps) => {
// 	return {
// 		dispatch1: () => {
// 			dispatch(actionCreator)
// 		},
// 	}
// }

export default connect(mapStateToProps, mapDispatchToProps)(Container)
